import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../Shared/Loader';
import { useRef } from 'react';
import AddSalesProductList from './AddSalesProductList';
import AddSalesInvoice from './AddSalesInvoice';
import { addUpdateDetails, selectCustomer } from '../../../../features/SalesSlice/SalesSlice';
import CustomerList from '../../../../hooks/CustomerList';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiCornerUpLeft, FiUser } from 'react-icons/fi';
import '../AddSales/MobileDefaultSales.css';


const ReturnBikeSalesInvoice = () => {
    // const { discount, dueAmount, grandTotal, payment, products, purchaseDate, purchaseInvoice, purchaseSupplier, totalAmount } = updateModal;
    const { posCustomer, isCustomer } = useSelector((state) => state.salesInvoice);
    const customer = useSelector((state) => state.salesInvoice.customer);
    const [isSearching, setIsSearching] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [searchText, setSearchText] = useState([]);
    const [loading, setLoading] = useState(true);
    const [customers, setCustomers] = useState([]);
    // const [details, setDetails] = useState();
    const [defaultCustomer, setDefaultCustomer] = useState(false);
    const [isChangeDate, setIsChangeDate] = useState(false);

    const { returnSales } = useSelector((state) => state.salesInvoice);


    const customerCodeRef = useRef('');
    const customerRef = useRef('');
    const dateRef = useRef('');
    const addressRef = useRef('');
    const phoneRef = useRef('');
    const openingRef = useRef('');
    const invoiceRef = useRef('');

    const dispatch = useDispatch();
    const location = useLocation();
    const isMobileReturn = location.pathname.startsWith('/mobile/');



    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getmaincustomers')
            .then(res => res.json())
            .then(data => {
                setCustomers(data);
                setLoading(false)
            })
    }, [])


    if (loading) {
        return <Loader />
    }

    const handleSearchResult = (event) => {
        setSearchText(event.target.value)
        const match = customers.filter(customer => customer.name.includes(searchText)
            || customer.name.toLowerCase().includes(searchText) ||
            customer.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const handleSelectCustomer = (customer) => {
        dispatch(selectCustomer(customer))
        setIsSearching(false)
        setSearchText('');
        setDefaultCustomer(true)

        setTimeout(() => { handleSalesDetails() }, 2000);
        // const purchaseInvoice = invoiceRef.current.value;
        // const purchaseSupplier = supplierRef.current.innerText;
        // const purchaseAddress = addressRef.current.innerText;
        // const purchasePhone = phoneRef.current.innerText;
        // const purchaseOpening = openingRef.current.innerText;
        // const purchaseDate = dateRef.current.value;
        // dispatch(addUpdateDetails({ purchaseInvoice, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseDate }))

    }


    const handleSalesDetails = (event) => {
        const salesInvoice = invoiceRef.current.value;
        const customerCode = customerCodeRef.current.innerText;
        const salesCustomer = customerRef.current.innerText;
        const salesAddress = addressRef.current.innerText;
        const salesPhone = phoneRef.current.innerText;
        const salesOpening = parseFloat(openingRef.current.innerText);
        const salesReturnDate = dateRef.current.value;
        // setDetails({ purchaseInvoice, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseDate })
        dispatch(addUpdateDetails({ salesInvoice, customerCode, salesCustomer, salesAddress, salesPhone, salesOpening, salesReturnDate }))
        setIsChangeDate(true);
    }


    if (isMobileReturn) {
        return <div className="mobile-sale-checkout mobile-return-checkout"><header className="mobile-sale-checkout__hero"><div><p className="mobile-sale-checkout__eyebrow"><FiCornerUpLeft />Touch sales return</p><h1>Return sale</h1><p>Invoice {returnSales?.salesInvoice || '—'}</p></div><Link className="mobile-sale-checkout__home" to="/mobile/managereturnsales" aria-label="Back to sales returns"><FiArrowLeft /></Link></header><section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiUser />Customer</h2><small>Original sale customer</small></div><div className="mobile-sale-checkout__customer-summary"><div className="mobile-sale-checkout__customer-card"><small>Customer</small><strong ref={customerRef}>{isCustomer === true ? posCustomer?.name : returnSales?.salesCustomer}</strong><span><span ref={customerCodeRef}>{isCustomer === true ? posCustomer?.code : returnSales?.customerCode}</span> · <span ref={phoneRef}>{isCustomer === true ? posCustomer?.phone : returnSales?.salesPhone}</span></span><span ref={addressRef} className="hidden">{isCustomer === true ? posCustomer?.address : returnSales?.salesAddress}</span></div><div className="mobile-sale-checkout__due-card"><small>Previous due</small><strong ref={openingRef}>{Number(isCustomer === true ? posCustomer?.opening : returnSales?.salesOpening || 0).toFixed(2)}</strong></div></div></section><section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiCalendar />Return details</h2><small>Review before return</small></div><div className="mobile-sale-checkout__meta-grid"><div className="mobile-sale-checkout__field"><label>Return date</label><input onChange={handleSalesDetails} ref={dateRef} type="date" value={returnSales?.salesDate || ''} /></div><div className="mobile-sale-checkout__field"><label>Invoice number</label><input onChange={handleSalesDetails} ref={invoiceRef} type="text" value={returnSales?.salesInvoice || ''} /></div></div></section><section className="mobile-sale-checkout__section mobile-default-sale-checkout__products"><div className="mobile-sale-checkout__section-head"><h2>Returned products</h2><small>Choose products and confirm amounts</small></div><AddSalesProductList /><AddSalesInvoice isChangeDate={isChangeDate} /></section></div>;
    }
    return (
        <div>
            <div className='w-full px-5 pb-5 my-5 text-xs'>
                <h1 className='text-lg text-center bg-primary p-3 text-white rounded-xl'>Return A Sales</h1>
                <div className='grid grid-cols-1 lg:grid-cols-12 gap-px'>
                    <div className='lg:col-span-4 mt-4'>
                        <table class="table w-1/2 mx-auto">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Select Date</th>
                                    <th className='bg-primary text-white normal-case'>Invoice No</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td><input onChange={handleSalesDetails} ref={dateRef} type="date" value={returnSales?.salesDate} className='rounded-lg bg-gray-200 p-3  text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                    <td><input onChange={handleSalesDetails} ref={invoiceRef} type="text" value={returnSales?.salesInvoice} className='rounded-lg bg-gray-200 p-3 w-40 text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <div class="form-control w-full lg:w-60 max-w-xs mt-5 col-span-2">
                        <div class="form-control lg:w-60 mx-auto">
                            
                            {/* <CustomerList handleSalesDetails={handleSalesDetails} customers={customers} /> */}
                    {/* <input onChange={handleSearchResult} value={searchText} type="text" placeholder="Search Supplier" class="rounded-lg bg-gray-300 text-textPrimary p-3 text-white text-center focus:border-blue-500 focus:outline-none w-full max-w-xs" />
                        </div>
                        <div style={isSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 bg-gray-200 p-2 ${isSearching ? 'h-16' : "h-8"} w-80 overflow-auto`}>
                            {
                                isSearching ? searchResult.map(customer =>
                                    <label for="update-modal" onClick={() => handleSelectCustomer(customer)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{customer?.name}</label>) :
                                    customers.map(customer =>
                                        <label for="update-modal" onClick={() => handleSelectCustomer(customer)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{customer?.name}</label>)
                            } */}
                    {/* </div>
                    </div> */}
                    <div className='lg:col-span-8 mt-4 overflow-auto lg:overflow-auto'>
                        <table class="table lg:w-1/2 lg:ml-2">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Customer Code</th>
                                    <th className='bg-primary text-white normal-case'>Customer Name</th>
                                    <th className='bg-primary text-white normal-case'>Customer Address</th>
                                    <th className='bg-primary text-white normal-case'>Mobile No</th>
                                    <th className='bg-primary text-white normal-case'>Previews Due</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td ref={customerCodeRef}>{isCustomer === true ? posCustomer?.code : returnSales?.customerCode}</td>
                                    <td onChange={handleSalesDetails} ref={customerRef} className='h-8'>{isCustomer === true ? posCustomer?.name : returnSales?.salesCustomer}</td>
                                    <td ref={addressRef}>{isCustomer === true ? posCustomer?.address : returnSales?.salesAddress}</td>
                                    <td ref={phoneRef}>{isCustomer === true ? posCustomer?.phone : returnSales?.salesPhone}</td>
                                    <td ref={openingRef}>{isCustomer === true ? posCustomer?.opening : returnSales?.salesOpening}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <br />

                </div>
                <div className='grid grid-cols-1 mt-8 relative'>
                    <AddSalesProductList />
                    <AddSalesInvoice isChangeDate={isChangeDate} />
                </div>
            </div>
        </div>
    );
};

export default ReturnBikeSalesInvoice;
